"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var ellipsis_v_icon_1 = tslib_1.__importDefault(require("@patternfly/react-icons/dist/js/icons/ellipsis-v-icon"));

var Toggle_1 = require("./Toggle");

exports.KebabToggle = function (_a) {
  var _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isOpen = _a.isOpen,
      isOpen = _a$isOpen === void 0 ? false : _a$isOpen,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Actions' : _a$ariaLabel,
      _a$parentRef = _a.parentRef,
      parentRef = _a$parentRef === void 0 ? null : _a$parentRef,
      _a$getMenuRef = _a.getMenuRef,
      getMenuRef = _a$getMenuRef === void 0 ? null : _a$getMenuRef,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      _a$isPlain = _a.isPlain,
      isPlain = _a$isPlain === void 0 ? false : _a$isPlain,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$bubbleEvent = _a.bubbleEvent,
      bubbleEvent = _a$bubbleEvent === void 0 ? false : _a$bubbleEvent,
      _a$onToggle = _a.onToggle,
      onToggle = _a$onToggle === void 0 ? function () {
    return undefined;
  } : _a$onToggle,
      ref = _a.ref,
      props = tslib_1.__rest(_a, ["id", "children", "className", "isOpen", 'aria-label', "parentRef", "getMenuRef", "isActive", "isPlain", "isDisabled", "bubbleEvent", "onToggle", "ref"]);

  return React.createElement(Toggle_1.Toggle, Object.assign({
    id: id,
    className: className,
    isOpen: isOpen,
    "aria-label": ariaLabel,
    parentRef: parentRef,
    getMenuRef: getMenuRef,
    isActive: isActive,
    isPlain: isPlain,
    isDisabled: isDisabled,
    onToggle: onToggle,
    bubbleEvent: bubbleEvent
  }, props), React.createElement(ellipsis_v_icon_1["default"], null));
};

exports.KebabToggle.displayName = 'KebabToggle';